module.exports = __webpack_public_path__ + "static/img/AR@2x.0d9c69a5.jpg";